import React from 'react'
import classnames from 'classnames/bind'

import useHttp from '@caudena/core/useHttp'
import { HeaderSlot } from '@caudena/core/Layout/slots'

import BlockClientForm from './BlockClientForm'
import SettingsHeader from '../SettingsHeader'

import { SettingsApiIntergrationData } from '../../../types/Settings'

import styles from './index.scss'
import buildUrl from '@caudena/core/utils/buildUrl'
import { getConfig } from '@caudena/core/useConfig'

const cx = classnames.bind(styles)

const ApiSettings = () => {
  const { data, mutate } = useHttp<SettingsApiIntergrationData>(
    buildUrl`${getConfig()?.COMPLIANCE_API}/api/settings/api_data`
  )

  const handleUpdateApiIntegrationData = (
    newData: Partial<SettingsApiIntergrationData>
  ) => {
    if (!data) return
    mutate({ ...data, ...newData })
  }

  const keys = React.useMemo(
    () => ({
      public: data?.public_key,
      private: data?.private_key,
    }),
    [data]
  )

  HeaderSlot.useContent(() => <SettingsHeader />)

  return (
    <div className={cx('Container')}>
      <BlockClientForm
        blockUrl={data?.block_url}
        whiteList={data?.white_list}
        keys={keys}
        onUpdate={handleUpdateApiIntegrationData}
      />
    </div>
  )
}

export default ApiSettings
